import React, { useState, Children } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
export function PressSection() {
  const [activeTab, setActiveTab] = useState('Highlights');
  const tabs = ['Highlights', 'Announcements', 'Awards'];
  const pressItems = {
    Highlights: [{
      date: 'OCTOBER 2025',
      title: 'Jibek Jolu Group Expands to New Flagship Location',
      publication: 'Eater'
    }, {
      date: 'AUGUST 2025',
      title: 'The Rise of Central Asian Cuisine in Modern Dining',
      publication: 'Food & Wine'
    }, {
      date: 'MAY 2025',
      title: 'A Culinary Journey: Inside the Jibek Jolu Empire',
      publication: 'The Culinary Times'
    }],
    Announcements: [{
      date: 'JANUARY 2026',
      title: 'Announcing Our New Corporate Catering Division',
      publication: 'Company Press Release'
    }, {
      date: 'NOVEMBER 2025',
      title: 'Jibek Jolu Group Appoints New Executive Chef',
      publication: 'Company Press Release'
    }, {
      date: 'SEPTEMBER 2025',
      title: 'Sustainability Initiatives for 2026 Outlined',
      publication: 'Company Press Release'
    }],
    Awards: [{
      date: 'DECEMBER 2025',
      title: 'Best Hospitality Group of the Year',
      publication: 'Restaurant Association'
    }, {
      date: 'JULY 2025',
      title: 'Excellence in Design: Jibek Jolu Flagship',
      publication: 'Architectural Digest'
    }, {
      date: 'MARCH 2025',
      title: 'Top 50 Places to Eat',
      publication: 'Local Dining Guide'
    }]
  };
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  return <section id="press" className="py-32 md:py-40 bg-white relative" data-id="element-261">
      <div className="max-w-6xl mx-auto px-6 md:px-12 relative z-10" data-id="element-262">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-20 gap-12" data-id="element-263">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-264">
            <h2 className="text-5xl md:text-6xl font-serif text-brand-dark mb-8" data-id="element-265">
              Press & Media
            </h2>
            <div className="w-24 h-1 bg-brand-red" data-id="element-266"></div>
          </motion.div>

          <motion.div className="flex flex-wrap gap-8 relative" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-267">
            {tabs.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`pb-4 text-sm uppercase tracking-[0.2em] transition-colors relative ${activeTab === tab ? 'text-brand-red font-medium' : 'text-brand-dark/50 hover:text-brand-dark'}`} data-id="element-268">
                {tab}
                {activeTab === tab && <motion.div layoutId="activeTab" className="absolute bottom-0 left-0 right-0 h-0.5 bg-brand-red" initial={false} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 30
            }} data-id="element-269" />}
              </button>)}
          </motion.div>
        </div>

        <div className="min-h-[500px]" data-id="element-270">
          <AnimatePresence mode="wait" data-id="element-271">
            <motion.div key={activeTab} variants={containerVariants} initial="hidden" animate="visible" exit={{
            opacity: 0,
            transition: {
              duration: 0.2
            }
          }} className="flex flex-col" data-id="element-272">
              {pressItems[activeTab as keyof typeof pressItems].map((item, index) => <motion.div variants={itemVariants} key={index} className="group border-b border-brand-dark/15 py-10 flex flex-col md:flex-row md:items-center justify-between gap-8 hover:bg-brand-beige/30 transition-colors px-6 -mx-6 rounded-sm" data-id="element-273">
                    <div className="flex items-start gap-8 flex-1" data-id="element-274">
                      <span className="text-brand-terracotta/30 font-serif text-4xl font-bold mt-1 select-none" data-id="element-275">
                        {(index + 1).toString().padStart(2, '0')}
                      </span>
                      <div data-id="element-276">
                        <span className="text-xs font-medium text-brand-red uppercase tracking-[0.2em] mb-3 block" data-id="element-277">
                          {item.date}
                        </span>
                        <h3 className="text-2xl md:text-3xl font-serif text-brand-dark group-hover:text-brand-red transition-colors leading-tight" data-id="element-278">
                          {item.title}
                        </h3>
                      </div>
                    </div>
                    <div className="flex items-center gap-8 md:pl-8" data-id="element-279">
                      <span className="text-brand-dark/50 font-serif italic text-base" data-id="element-280">
                        {item.publication}
                      </span>
                      <Link to="/press" className="w-12 h-12 rounded-full border border-brand-dark/20 flex items-center justify-center text-brand-dark group-hover:bg-brand-red group-hover:border-brand-red group-hover:text-white transition-all transform group-hover:translate-x-2 shrink-0" data-id="element-281">
                        →
                      </Link>
                    </div>
                  </motion.div>)}
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-16 text-center" data-id="element-282">
          <Link to="/press" className="text-brand-dark border-b border-brand-dark pb-2 text-sm uppercase tracking-[0.2em] hover:text-brand-red hover:border-brand-red transition-colors font-medium" data-id="element-283">
            View All Press
          </Link>
        </div>
      </div>
    </section>;
}